import { CustomRoleFeatureKeys } from 'src/security/customRoleFeatureKeys';
import Roles from 'src/security/roles';

function hasTaskKanbanGestorFeature(
  featureKeys: Iterable<string> | null | undefined,
): boolean {
  if (!featureKeys) {
    return false;
  }
  for (const k of featureKeys) {
    if (k === CustomRoleFeatureKeys.taskKanbanGestor) {
      return true;
    }
  }
  return false;
}

/**
 * Capacidad custom `taskKanbanGestor`: mismo conjunto de permisos que concede el rol fijo
 * `kanbanAdmin` (cualquier permiso cuyo `allowedRoles` incluya ese rol).
 */
export function taskKanbanGestorFeatureGrantsKanbanAdminEquivalent(
  featureKeys: Iterable<string> | null | undefined,
  permission: {allowedRoles?: readonly unknown[] | null} | null,
): boolean {
  if (!permission?.allowedRoles?.length) {
    return false;
  }
  if (!hasTaskKanbanGestorFeature(featureKeys)) {
    return false;
  }
  return permission.allowedRoles.includes(Roles.values.kanbanAdmin);
}
